<div class="api-overview">
    <div class="items">
        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ 'apiKeys.title' | t }}</div>
            @if (canEdit) {
                <div class="detail-page-card-actions">
                    <button class="btn btn-raised" data-uiid="apikey-add" (click)="new()">
                        <i class="fas fa-plus me-2"></i>{{ 'apiKeys.addButton' | t }}
                    </button>
                    <div class="spacer"></div>
                    <button type="button" class="btn btn-raised green" (click)="loadData()">
                        <i class="fas fa-sync me-2"></i>{{ 'apiKeys.refreshButton' | t }}
                    </button>
                </div>
            }
            <div class="detail-page-card-body">
                @for (key of apiKeys; track key) {
                    <div
                        class="item"
                        [attr.data-uiid]="'apikey-item-' + key.id"
                        [class.selected]="selected && key.id === selected.id"
                        (click)="open(key)"
                    >
                        {{ key.name }}
                    </div>
                }
            </div>
        </div>
    </div>

    <div class="detail">
        @if (selected && canEdit) {
            <div class="detail-page-action-bar">
                <button class="btn btn-cerrix btn-sm" data-uiid="apikey-save" (click)="save()">
                    <i class="fas fa-save"></i>
                    <span class="d-none d-lg-inline">{{ 'apiKeys.saveButton' | t }}</span>
                </button>

                <div class="right-area">
                    <button class="btn btn-dark btn-sm" (click)="openManual()">
                        <i class="fas fa-question-circle"></i>
                        <span class="d-none d-lg-inline ms-2">{{ 'apiKeys.apiUsageButton' | t }}</span>
                    </button>
                    @if (selected.id > 0) {
                        <button class="btn btn-danger btn-sm" data-uiid="apikey-delete" (click)="delete()">
                            <i class="fal fa-trash"></i>
                            <span class="d-none d-lg-inline">{{ 'apiKeys.deleteButton' | t }}</span>
                        </button>
                    }
                </div>
            </div>
        }
        <div class="edit-area">
            @if (!selected) {
                <div class="no-selection-message">
                    <span>{{ 'apiKeys.selectOrCreate' | t }}</span>
                </div>
            }
            <api-key-detail></api-key-detail>
        </div>
    </div>
</div>
